import useFilter from 'hooks/useFilter'
import useFetch from 'hooks/useFetch'
import { usePagination } from 'hooks'

import {
  Container,
  ContentHeader,
  FilterButton,
  Filters,
  LoadingFeedback,
  Page,
  Card,
} from 'components'
import { GovernanceProjectsTable } from './components'
import { Box, TablePagination, useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'

import * as service from 'service'

const GovernanceProjectsMain = () => {
  const filter = useFilter()
  const theme = useTheme()

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination()

  const { response, isLoading, refresh } = useFetch(
    service.backoffice.governanceProjects.get,
    {
      ...filter.filters,
      perPage,
      page,
    },
    [page, perPage, filter.filters],
  )

  return (
    <Page title="Projetos de Governança">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader
          menu="Projetos de Governança"
          title="Listagem"
          subtitle="Exibição dos projetos de governança"
        >
          <FilterButton setDrawerOpen={filter.setDrawerOpen} />
        </ContentHeader>
        <Box my={2}>
          <Card title="Projetos de Governança" fromTable>
            <GovernanceProjectsTable
              governanceProjects={response?.data?.governanceProjects || []}
              refresh={refresh}
            />
            <Box px={2} display="flex" justifyContent="flex-end">
              <TablePagination
                component="div"
                count={response?.data?.meta?.totalCount || 0}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                page={page - 1}
                rowsPerPage={perPage}
                rowsPerPageOptions={[5, 10, 25, 100]}
                labelRowsPerPage={isDesktop ? 'Por página' : ''}
                nextIconButtonProps={{ size: 'small' }}
                backIconButtonProps={{ size: 'small' }}
              />
            </Box>
          </Card>
          <Filters filter={filter}>
            <input textfieldinput="true" label="Identificador" name="id" />
            <input textfieldinput="true" label="Nome do projeto" name="name" />
            <input
              textfieldinput="true"
              label="ID da empresa"
              name="company_id"
            />
          </Filters>
        </Box>
      </Container>
    </Page>
  )
}

export default GovernanceProjectsMain
